<template>
<v-content id="help">
  <v-container pa-0>

  </v-container>
</v-content>
</template>

<script>
export default {
  name: 'help',
  data() {
    return {
      tab: null,
      helptext: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      helptext2: 'lorem ipsuminator'
    }
  }
}
</script>

<style>
#help {
  background-image: url('../assets/paper_bkgd.png');
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  position: relative;
  font-family: "1942";
  font-weight: "bold";
}
</style>
